import { Box, Typography } from '@mui/material';

export default function NewBadge({ label }) {
  return (
    <Box
      sx={{
        background:
          'linear-gradient(90deg, #F9512C 0%, #DE33B4 50.16%, #0000FF 100%)',
        borderRadius: '24px',
      }}
    >
      <Typography
        sx={{
          color: 'white',
          fontSize: '12px',
          fontWeight: 500,
          padding: '1px 6px',
        }}
      >
        {label || 'Nuevo'}
      </Typography>
    </Box>
  );
}
